import { Clickable, Section } from '@ahmdigital/ui';
import styled from 'styled-components';

export const StyledSection = styled(Section)`
  margin: auto;
  padding: 0 1rem;
  @media (min-width: ${(props) => props.theme.media.md}) {
    padding: 0;
  }
`;

export const PhoneNumberClickable = styled(Clickable)`
  margin-left: 0.25rem;
`;

type ImageWrapperProps = {
  isFallbackImage: boolean;
};

export const ImageWrapper = styled.div<ImageWrapperProps>`
  text-align: center;
  text-align: center;
  ${({ isFallbackImage }) =>
    isFallbackImage &&
    `
      img {
        min-height: 276px;
      }
    `}
`;
